export default {
    reset_email_title: "Change Email",
    reset_email_message: "Do you want to change the email?",
    reset_email_success_message: "The email has been reset",
    reset_email_error_message: "Unable to change email due to an error",
    reset_email_new_email: "New Email",
    reset_email_current_email: "Current Email",
    reset_email_email_already_registered: "The email is already registered",
};